import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import { Icon } from './about/index';
import { NumberCount } from './about/index';

class About extends Component {
    render() {
        return (
            <section className="about-me t2 s3 shape-am position-relative" id="about">
                <div className="section-icons">
                    <Icon />
                </div>
                <div className="container">
                <div className="row position-relative">
                    <div className="col-lg-7 animate-element wow delay5 fadeInDown">
                        <div className="flat-title t2">
                            <h4 className="sub-title mg-b22">About Me</h4>
                            <h2 className="title-section color-d11 mg-b41">Hi, I am here to help your next project!</h2>
                            <div className="description">
                                <p className="color-d13 lt-sp01">
                                    Hello, my name is David Losilla, I am a {Math.abs(new Date(Date.now() - new Date('1993-05-23T00:00:00')).getUTCFullYear() - 1970)} years old computer engineer from Madrid, passionate about new technologies and the world of computers.</p>
                                <p className="color-d13 lt-sp01">
                                    My adventure began in 2015 studying the degree of computer engineering, since then I have worked for 5 companies in which I have grown professionally and personally to overcome the different challenges they have posed.</p>
                            </div>
                        </div>
                    </div>
                    <div className="fact">
                        <NumberCount />
                        <div className="btn-contact bg-s2 text-center">
                            <h4 className="title color-d11">Get a project? Let’s talk.</h4>
                            <a href="mailto:dlosilla.work@gmail.com" className="email color-s2 color-d15">dlosilla.work@gmail.com</a>
                        </div>
                    </div>
                </div>
                </div>
                <div className="featured-post animate-element wow delay5 fadeInUp" data-wow-delay="0.5s">
                <img src="images/section/51.png" alt="images" />
                </div>
            </section>
        );
    }
}

export default About;
